module.exports = __webpack_public_path__ + "static/media/red-right-chevron.9f3a2a81.svg";